/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
const dtUpdate  = require ('./users-dt-update')
const timeTime  = require('../../../../../js-handler/time-time')
const settings  = require('../../../../../js-handler/settings')
const websocket = require('../../../../../js-network/web-socket')
const string    = require('../../../../../js-handler/string')







export const tableDetail = {
    entity: 'users',
    dest: 'users',

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"users", "elem":"fullcont", "id":"users-fullcont", 
                                              "act":"selectOne", "entity":"users", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{ "dest":"users", "elem":"dt", "act":"trMenu", 
                                                  "id":"trMenu",  "entity":"users", 
                                                   "dbid": "#dbid"  } ]  }'`, //"username": "#username"

    filter: {
        mainFilterFields : ["__name", "last_name", "users.username"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Reulsts', span: '---' },
                                                { label:'No Reulsts', span: '---' } ] })
        return newData
    }


    data.forEach((elem)=>{

        const statusStyle  = dtUpdate.getstatusStyle(elem)   
        
        if(!elem.hasOwnProperty('sex')){
            elem.sex = "NA";
        }

        newData.push(
                {   id: elem.id, sex: elem.sex,  // username:elem.username,
                    trDetail:  `data-users = '{"company":"${string.removeSpecialCharacters(elem.company)}"}'`, 
                     colum: [  { 
                           label: elem.username, span: elem.__name +" " + elem.last_name,
                            style:{ 
                                tdClass:'td-bluex tdWithAvatar tdWithAvatar-state',  
                                avatar:elem.avatar,  
                                avatarColor: '', 
                                avatarColorLetter: '', 
                                avatarLetter: ''                       
                            } 
                                 },
                                 { label: elem.type,  span: elem.entities        },   
                                 
                                 {  label: statusStyle.title,  
                                    span: statusStyle.des
                                 },
                                 { label: '',  span: '',
                                    style:{ 
                                        tdClass:`deviceBrowser`  
                                    } 
                                 },  
                                 { label: '--:--',  span: elem.request_qty,
                                    style:{ 
                                        tdClass:`loginTime`  
                                    } 
                                 }   ]    
                }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/



export function lineUpdate(user,htmlDt) {

    if (user.typeApp === 'nurse') { return }

	const HTMLrow = document.getElementById(`${htmlDt.dest}-tableRow-${user.id}`)

    HTMLrow.classList.add('tdWithAvatar-state-up')  

    // HTMLrow.querySelector('.deviceBrowser').querySelector('label').innerHTML = user.device.deviceOs + ' - ' + user.device.deviceType + ' - ' +
    // user.device.deviceVersion;
    let navegator = user.device.navegatorType + ' - ';
    HTMLrow.querySelector('.deviceBrowser').querySelector('label').innerHTML =  user.device.navegatorName + ' - ' +
    user.device.navegatorVersion;

    const lasTimeActive = timeTime.getTimeDiff(user.time)
    const ago = `${lasTimeActive.hour} : ${lasTimeActive.min} : ${lasTimeActive.seg} `

    const label = HTMLrow.querySelector('.loginTime').querySelector('label');

    label.innerHTML  = ago;
    label.setAttribute('data-time', user.time) 


}/*device update*/

export function joinAdminReplay(detail,htmlDt){  
    lineCleanAll(htmlDt) 
    
    detail.user.forEach((user) => {
         lineUpdate(user,htmlDt)    
    })/*companies*/ 

}/*updateUser*/



//clean the up time for all the elments 
export function lineCleanAll(htmlDt){ //console.log( 'lineCleanAll>' )
        
    //turn down all the avatars
    const allAvatar = htmlDt.entityDt.querySelectorAll('.tdWithAvatar-state-up')

    allAvatar.forEach((avatar)=>{ //console.log('compannYYY>', company)
        avatar.classList.remove('tdWithAvatar-state-up') 
    })


    const allLastUpdateDetail = htmlDt.entityDt.querySelectorAll('.loginTime label');

    allLastUpdateDetail.forEach((lastUpdateDetail)=>{ //console.log('compannYYY>', company)
        lastUpdateDetail.innerHTML = `--:--`; 
        lastUpdateDetail.setAttribute('data-time', '')
    })

}/**/

//keep the timer for each user active
export function lastupdateTimer(htmlDt) {
    const timer = setInterval(() => { // console.log( 'setInterval>' )


        const allLastUpdateDetail = htmlDt.entityDt.querySelectorAll('.loginTime label');


        allLastUpdateDetail.forEach((unit) => {

            let unitTime = unit.getAttribute('data-time')




            if (unitTime != '' && unitTime != undefined && unitTime != null) {

                const lastTimeActive = timeTime.getTimeDiff(new Date(unitTime))
                //  console.log( 'lastTimeActive>', lastTimeActive )

                unit.innerHTML = `${lastTimeActive.hour} : ${lastTimeActive.min} : ${lastTimeActive.seg} `
            }
        })/*companies*/

    }, 2000)/*mapTimer*/
}/**/


//we we get an activity update, we have to update the line and the company timer
export function activityUpdates(data,htmlDt){ //  console.log('activityUpdates ', data)

    if( data.typeApp === 'nurse'){ return }

	const elem = document.getElementById(`${htmlDt.dest}-tableRow-${data.id}`)

    const lastUpdateDetail = elem.querySelector('.loginTime').querySelector('label');


    // si no encuentra el ultimo detalle de actualizacion salir
    if (lastUpdateDetail == null) {
        return;
    }

    lastUpdateDetail.setAttribute('data-time', data.time)

    const lasTimeActive = timeTime.getTimeDiff(data.time)
    const newTime       = `${ lasTimeActive.hour } : ${ lasTimeActive.min  } : ${ lasTimeActive.seg  } `

    lastUpdateDetail.innerHTML        = newTime


}/**/

export function joinAdmin(){  ///console.log(`joinAdmin EXTERNAL`, ); 

    const data = settings.getDataWs()
    if( data.right === 'admin' || data.right === 'adminGosive' ){ 

        var timer = setInterval(()=>{    
           
           if( websocket.ws != undefined){
                //25/10/2023 marco molina
                //if( websocket.ws.readystate === 1 ){ 
                if( websocket.ws.connected == true ){ 
               
                    websocket.send({  act: "joinAdmin", data: data  })
                    clearInterval(timer)
               }            
           }/*if*/

       }, 1000)/*setInterval*/

    }/*if*/
}/**/




//when user left, remove the up indicator and change the label for time
export function leftOne(user,htmlDt){   //console.log('leftOne>')

	const HTMLrow = document.getElementById(`${htmlDt.dest}-tableRow-${user.id}`)

    HTMLrow.classList.remove('tdWithAvatar-state-up') 


    const lastUpdateDetail = HTMLrow.querySelector('.loginTime').querySelector('label');

    lastUpdateDetail.setAttribute('data-time', '')

    lastUpdateDetail.innerHTML = `${timeTime.formatAMPM()}`
    lastUpdateDetail.title     = 'User left at'

}/**/



